/**
 * Filter state reducer
 * Manages all filter-related state (payment status, invoice status, invoice type, users, dates)
 */

export const filterReducer = (state, action) => {
  switch (action.type) {
    case 'SET_SELECTED_DATE':
      return { ...state, selectedDate: action.payload };
    
    case 'SET_PAYMENT_STATUS_FILTER':
      return { ...state, paymentStatusFilter: action.payload };
    
    case 'SET_STATUS_FILTER':
      return { ...state, statusFilter: action.payload };
    
    case 'SET_INV_TYPE_FILTER':
      return { ...state, invTypeFilter: action.payload };
    
    case 'SET_USER_FILTER':
      return { ...state, userFilter: action.payload };
    
    case 'SET_INVOICE_NUMBER_FILTER':
      return { ...state, invoiceNumberFilter: action.payload };
    
    case 'SET_INV_NUM_FILTER':
      return { ...state, invNumFilter: action.payload };
    
    case 'SET_DEBOUNCED_VALUE':
      return { ...state, debouncedValue: action.payload };
    
    case 'SET_DATE_RANGE':
      return { ...state, dateRange: action.payload };
    
    // Team filter
    case 'SET_SELECTED_TEAMS':
      return { ...state, selectedTeams: action.payload };
    
    case 'SET_SELECT_ALL_TEAM':
      return { ...state, selectAllTeam: action.payload };
    
    case 'SET_USER_SEARCH_TERM':
      return { ...state, userSearchTerm: action.payload };
    
    // Status filter
    case 'SET_SELECTED_STATUS':
      return { ...state, selectedStatus: action.payload };
    
    case 'SET_SELECT_ALL_STATUS':
      return { ...state, selectAllStatus: action.payload };
    
    // Payment status filter
    case 'SET_SELECTED_PAYMENT_STATUS':
      return { ...state, selectedPaymentStatus: action.payload };
    
    case 'SET_SELECT_ALL_PAYMENT_STATUS':
      return { ...state, selectAllPaymentStatus: action.payload };
    
    case 'SET_PAYMENT_STATUS_SEARCH_TERM':
      return { ...state, paymentStatusSearchTerm: action.payload };
    
    // Invoice type filter
    case 'SET_SELECTED_INV_TYPES':
      return { ...state, selectedInvTypes: action.payload };
    
    case 'SET_SELECT_ALL_INV_TYPE':
      return { ...state, selectAllInvType: action.payload };
    
    case 'CLEAR_FILTERS':
      return {
        ...state,
        invNumFilter: "",
        invoiceNumberFilter: "",
        debouncedValue: "",
        selectedDate: null,
        dateRange: null,
        // Reset to defaults - these will be set by useEffect hooks
      };
    
    default:
      return state;
  }
};

export const initialFilterState = {
  selectedDate: null,
  paymentStatusFilter: [],
  statusFilter: [],
  invTypeFilter: [],
  userFilter: [],
  invoiceNumberFilter: "",
  invNumFilter: "",
  debouncedValue: "",
  // dateRange: null is valid - code handles null properly with Array.isArray() checks
  // When set, it becomes [startDate, endDate] array
  dateRange: null,
  // Team filter
  selectAllTeam: true,
  selectedTeams: [],
  userSearchTerm: '',
  // Status filter
  selectAllStatus: true,
  selectedStatus: [],
  // Payment status filter
  selectAllPaymentStatus: true,
  selectedPaymentStatus: [],
  paymentStatusSearchTerm: '',
  // Invoice type filter
  isInvTypeDropdownOpen: false,
  isInvTypeModalDropdownOpen: false,
  selectedInvTypes: [],
  selectAllInvType: true,
};

